export enum ResponseStatus {
  SUCCESS = 200,
  UNAUTHORIZED = 401,
  INTERNAL_SERVER_ERROR = 500,
}
